import { err } from "api/endpoints";
import { importView } from "../utils/misc";

const ErrMsgs = importView("Msg");
// const ErrMsg = importView("Msg/Form");

const errorRoutes = {
  path: "/",
  children: [
    {
      path: err.msgs,
      element: <ErrMsgs />,
    },
    // {
    //   path: `${err.msg}/:id`,
    //   element: <ErrMsg />,
    // },
  ],
};

export default errorRoutes;
